import React from "react"
import { graphql, StaticQuery, Link } from "gatsby"
import styled from "@emotion/styled"
import { breakpoints, color } from "../../utils/style"
import Img from "gatsby-image"
import Diamond from "../../icons/svg/Diamond"
import GetWindowWidth from "../shared/GetWindowWidth"

const BlockWrapper = styled("div")`
  background-color: ${color.transparentDarkRed6};
  position: relative;
  border: 4px solid ${color.red};
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(104, 0, 0, 0.3);
  backdrop-filter: blur(12px);
  padding: 0 35px;
  margin: 40px 0;
  overflow: hidden;
  .background-icon {
    display: block;
    position: absolute;
    width: 100%;
    max-width: 360px;
    right: 0;
    bottom: 0;
    z-index: -1;
  }
  @media (max-width: ${breakpoints.sm}) {
    .background-icon {
      max-width: 560px;
      left: 0;
      margin: 0 auto;
    }
  }
`

const GameTypesWrap = styled("div")`
  margin-top: 40px;
  .games {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
    margin: 0 -10px;
    width: 100%;
    max-width: 70%;
    margin-bottom: 30px;
  }
  .game {
    flex-basis: 30%;
    padding: 10px;
    text-align: center;
    margin-bottom: 10px;
    .image-wrap {
      min-height: 106px;
      margin-bottom: 20px;
    }
    .gatsby-image-wrapper {
      width: 100%;
      max-width: 86px;
      display: block;
      margin: 0 auto;
    }
    .button {
      width: 100%;
    }
  }
  @media (max-width: ${breakpoints.md}) {
    .games {
      max-width: 100%;
    }
    .game {
      flex-basis: 50%;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    .game {
      flex-basis: 100%;
    }
  }
`

const GameTypes = () => {
  return (
    <StaticQuery
      query={graphql`
        {
          allWordpressPage(filter: { slug: { eq: "home-page" } }) {
            edges {
              node {
                acf {
                  game_types {
                    alt_text
                    title
                    path
                    acf {
                      slide_url
                      slide_title
                      slide_description
                    }
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 105) {
                          ...GatsbyImageSharpFluid_withWebp_noBase64
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          background: file(relativePath: { eq: "game-types-bg.png" }) {
            childImageSharp {
              fluid(maxWidth: 360) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
          background_mobile: file(
            relativePath: { eq: "game-types-bg-mobile.png" }
          ) {
            childImageSharp {
              fluid(maxWidth: 560) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      `}
      render={data => {
        const windowWidth = GetWindowWidth()
        const isDesktop = windowWidth > 600
        const page = data?.allWordpressPage?.edges[0]?.node
        const gallery = page?.acf?.game_types
        return (
          <BlockWrapper>
            <h2 className="h1 with-icon rich-design">
              <Diamond />
              <span>เกมเด่นของ รอยัล1688</span>
            </h2>
            <div className="background-icon">
              {isDesktop ? (
                <Img
                  fluid={data.background.childImageSharp.fluid}
                  alt={"royal-1688.net"}
                  fadeIn={false}
                  loading="eager"
                />
              ) : (
                <Img
                  fluid={data.background_mobile.childImageSharp.fluid}
                  alt={"royal-1688.net"}
                  fadeIn={false}
                  loading="eager"
                />
              )}
            </div>
            <GameTypesWrap>
              <div className="games">
                {gallery?.map((item, index) => {
                  const localFile = item?.localFile || {}

                  return (
                    <div className="game" key={index + Math.random() * 100}>
                      <div className="image-wrap">
                        {localFile?.childImageSharp &&
                          localFile?.childImageSharp?.fluid && (
                            <Img
                              fluid={localFile.childImageSharp.fluid}
                              alt={
                                item.alt_text ? item.alt_text : "royal-1688.net"
                              }
                              fadeIn={false}
                              loading="eager"
                            />
                          )}
                      </div>
                      {item?.acf?.slide_title && item?.acf?.slide_url && (
                        <div>
                          <Link
                            to={item.acf.slide_url}
                            className="button transparent-button-gold"
                          >
                            {item.acf.slide_title}
                          </Link>
                        </div>
                      )}
                    </div>
                  )
                })}
              </div>
            </GameTypesWrap>
          </BlockWrapper>
        )
      }}
    />
  )
}

export default GameTypes
